if (!customElements.get('ma-faq-section')) {
  customElements.define('ma-faq-section', class extends HTMLElement {
    connectedCallback() {
      this._triggers = Array.from(this.querySelectorAll('[data-faq-trigger]'));
      this._triggers.forEach(btn => btn.addEventListener('click', this._onToggle.bind(this)));

      if (this.dataset.openFirst !== undefined && this._triggers.length > 0) {
        this._openItem(this._triggers[0]);
      }
    }

    _openItem(trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      const answer = trigger.closest('[data-faq-item]')?.querySelector('[data-faq-answer]');
      if (answer) answer.hidden = false;
    }

    _closeItem(trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      const answer = trigger.closest('[data-faq-item]')?.querySelector('[data-faq-answer]');
      if (answer) answer.hidden = true;
    }

    _onToggle(e) {
      const trigger = e.currentTarget;
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';

      this._triggers.forEach(t => this._closeItem(t));

      if (!wasOpen) this._openItem(trigger);
    }
  });
}
